import React from 'react';
import FeatureRequestsApp from './FeatureRequestsApp';

function FeatureRequestsWrapper() {
  return (
    <div className="feature-requests-wrapper">
      <FeatureRequestsApp />
    </div>
  );
}

export default FeatureRequestsWrapper;
